"use client";

import { Button } from "@/components/ui/button";
import { useDelegation } from "@/hooks/use-delegation";
import { ArrowLeft } from "lucide-react";

export function DelegationBanner() {
  const { isDelegating, currentDelegation, returnToMyAccount } = useDelegation();

  // Only show banner when delegating
  if (!isDelegating || !currentDelegation) {
    return null;
  }

  const typeIcon = currentDelegation.type === 'organization' ? '📊' : '🏢';
  const typeLabel = currentDelegation.type === 'organization' ? 'Organization' : 'Integrator';

  return (
    <div className="bg-gradient-to-r from-orange-100 to-amber-100 border-b border-orange-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2">
              <span className="text-lg">{typeIcon}</span>
              <div>
                <div className="text-sm font-medium text-orange-900">
                  Managing as <strong>{currentDelegation.name}</strong>
                </div>
                <div className="text-xs text-orange-700">
                  {typeLabel} • All actions are performed on behalf of this entity
                </div>
              </div>
            </div>
          </div>
          
          <Button
            variant="outline"
            size="sm"
            onClick={returnToMyAccount}
            className="border-orange-300 text-orange-900 hover:bg-orange-200 hover:border-orange-400"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Return to My Account
          </Button>
        </div>
      </div>
    </div>
  );
}